/*
 * Copyright © 2020-2022 Ocean Galaxy Inc. All Rights Reserved.
 * @Description:
 * @LastEditors: garry彭
 * @LastEditTime: 2023-10-26 19:31:30
 */
/* eslint-disable */
import fetch from 'isomorphic-fetch'
import { message } from 'antd'
import actionTypes from '../constants/actionTypes'
import generateFullUrl from '../utils/generateFullUrl'
import * as SentryUtils from '../utils/sentryUtils'
import desktopLib from './desktopLib'
import {
  isFailedFetchError,
  shouldWarnNetworkUnavailable
} from './requestSafety'

/*
  config: {
    url: 'http://',
    requestPath: /home/id,
    parameter: {customer: 123, id: 0},
    arguments: {
      method: 'POST',
      body: JSON.stringify({
        'phone': phone,
        'password': password
      })
    },
    failCallback: function(){}
  }
*/

export default function fetchHelper(dispatch, getState, config) {
  config.checkCurrent?.()
  return fetch(
    generateFullUrl(config),
    Object.assign(config.arguments || {}, { credentials: 'include' })
  )
    .then((response) => {
      config.checkCurrent?.()
      if (!response.ok) {
        if (response.status === 401) {
          dispatch({
            type: actionTypes.CLEAR
          })
        } else if (response.status === 404) {
          return Promise.reject({
            type: response.status,
            reason: response.statusText,
            response: {}
          })
        }
        return Promise.reject({
          type: response.status,
          reason: response.statusText
        })
      }
      return response.json()
    })
    .then((result) => {
      config.checkCurrent?.()
      if (result.code === 401) {
        dispatch({
          type: actionTypes.CLEAR
        })
        if (
          config.url !==
          __API_SERVER_HOST__ + '/web/workgroup/v2/currentuser'
        ) {
          message.error('登录状态失效，请重新登录')
        }
        if (getState().main.isDesktop) {
          desktopLib.logoutSuccess()
        }
        return Promise.reject(null)
      }
      if (result.code === 400) {
        return Promise.reject(result)
      }
      return result
    })
    .catch((err) => {
      // 迟到的 401 和网络失败不能清理新账号，也不应弹出上一团队的错误。
      config.checkCurrent?.()
      if (isFailedFetchError(err)) {
        // navigator.onLine 只是浏览器的连接提示，VPN/代理/网络切换时可能误报。
        // 先实际发起请求，确认 fetch 失败后再根据离线状态提示，避免阻断登录。
        if (
          shouldWarnNetworkUnavailable(
            err,
            typeof navigator === 'undefined' ? true : navigator.onLine
          )
        ) {
          message.warning('当前网络异常，请稍后再试')
        }
        return Promise.reject(null)
      }
      SentryUtils.captureFetchException(err, config)
      return Promise.reject(null)
    })
}
